function getCustomerType() {
  return {
    'ZJ_JL': {
      value: 1,
      label: '总监经理属公司合同员工'
    },
    'YW': {
      value: 2,
      label: '业务员'
    },
    'JMS': {
      value: 3,
      label: '加盟商'
    }
  }
}

function getSysAddrType() {
  return {
    'TOP': {
      value: 0,
      label: '0-国家级别【特殊地区例如：港澳台也用0】'
    },
    'SHEN': {
      value: 1,
      label: '省'
    },
    'SHI': {
      value: 2,
      label: '市'
    },
    'QU': {
      value: 3,
      label: '区'
    }
  }
}

function getGoodsState() {
  return {
    'UP': {
      value: 1,
      label: '上架'
    },
    'DOWN': {
      value: 2,
      label: '下架'
    }
  }
}

function getYesOrNo() {
  return {
    'NO': {
      value: 0,
      label: '否'
    },
    'YES': {
      value: 1,
      label: '是'
    }
  }
}

function getCommStatus() {
  return {
    'FORBIDDEN': {
      value: 0,
      label: '禁用'
    },
    'NORMAL': {
      value: 1,
      label: '正常'
    }
  }
}

function getMenuType() {
  return {
    // 'REQUEST': {
    //   value: 	 4,
    //   label: '请求'
    // },
    'MENU_GROUP': {
      value: 1,
      label: '目录'
    },
    'MENU': {
      value: 2,
      label: '菜单'
    },
    'BUTTON': {
      value: 3,
      label: '按钮'
    },
    // 'OTHER': {
    //   value: 9,
    //   label: '其他'
    // }
  }
}

function getCategorizeType() {
  return {
    'GOODS_VIEW': {
      value: 1,
      label: '商品分类,如商品列表左侧显示的分类'
    },
    'GOODS_BUYAREA': {
      value: 2,
      label: '购买区域商品分类,如积分秒杀余额等'
    }
  }
}

function getGoodsAuth() {
  return {
    'BUY': {
      value: 1,
      label: '购买商品权限'
    },
    'PRICE': {
      value: 2,
      label: '商品看价格权限'
    }
  }
}
//订单类型
function getOrderType() {
  return {
    'GOODS_ORDER': {
      value: 11,
      label: '订货订单'
    },
    'POINT_ORDER': {
      value: 12, 
      label: '积分订单'
    },
    'SECKILL_ORDER': {
      value: 13,
      label: '秒杀订单'
    },
    'EXCHANGE_ORDER': {
      value: 14,
      label: '换货订单'
    },
    'ONLINE_TUITION': {
      value: 2,
      label: '在线支付学费'
    },
    'ONLINE_RECHARGE': {
      value: 3,
      label: '在线支付充值'
    },
    'OFFLINE_TUITION': {
      value: 4,
      label: '线下支付学费'
    },
    'OFFLINE_RECHARGE': {
      value: 5,
      label: '线下支付充值'
    },
    'COURSE_ORDER': {
      value: 6,
      label: '课程订单'
    },
    'MEETING_ORDER': {
      value: 7,
      label: '会议订单'
    },
    'AFTER_ORDER': {
      value: 8,
      label: '售后单'
    }
  }
}
//业务身份和加盟商
function getUserLevel() {
  return {
    'ZONGJIAN': {
      value: 1,
      label: '总监'
    },
    'YINGXIANGJINGLI': {
      value: 2,
      label: '营销经理'
    },
    'DAQUJIANLI': {
      value: 3,
      label: '大区经理'
    },
    'DIQUJIANLI': {
      value: 4,
      label: '地区经理'
    },
    'XIANQUJIANLI': {
      value: 5,
      label: '县区经理'
    },
    'YANXIUBAN': {
      value: 6,
      label: '研修班'
    },
    'TIYANBAN': {
      value: 7,
      label: '体验班'
    },
    'PUTON_USER': {
      value: 8,
      label: '普通人员'
    }
  }
}
//直播身份
function getLiveAnchorLevel() {
  return {
    'ZONGJIAN': {
      value: '营销总监',
      label: '营销总监'
    },
    'YINGXIANGJINGLI': {
      value: '营销经理',
      label: '营销经理'
    },
    'DAQUJIANLI': {
      value: '大区经理',
      label: '大区经理'
    },
    'DIQUJIANLI': {
      value: '地区经理',
      label: '地区经理'
    },
    'XIANQUJIANLI': {
      value: '县区经理',
      label: '县区经理'
    },
    'JIAOYUZONGJIAN': {
      value: '教育总监',
      label: '教育总监'
    },
    'DUDAO': {
      value: '督导',
      label: '督导'
    },
    'JISHULAOSHI': {
      value: '技术老师',
      label: '技术老师'
    },
    'FUWUZONGJIAN': {
      value: '服务总监',
      label: '服务总监'
    },
    'DAIJIAOLAOSHI': {
      value: '带教老师',
      label: '带教老师'
    }
  }
}      
//业务身份
function getSearchUserLevel() {
  return {

    'DAQUJIANLI': {
      value: 3,
      label: '大区经理'
    },
    'DIQUJIANLI': {
      value: 4,
      label: '地区经理'
    },
    'XIANQUJIANLI': {
      value: 5,
      label: '县区经理'
    },
    'YANXIUBAN': {
      value: 6,
      label: '研修班'
    },
    'TIYANBAN': {
      value: 7,
      label: '体验班'
    }
  
  }
}
//申请类型
function getProcessingType() {
  return {
    'RECRUIT_SALESMAN': {
      value: 1,
      label: '招募业务员'
    },
    'ADJUST_SALESMAN_AREA': {
      value: 2,
      label: '调整业务员区域'
    },
    'MODIFY_SALESMAN_IDENTITY': {
      value: 3,
      label: '修改业务员身份'
    },
    'SALESMAN_RESIGNATION': {
      value: 4,
      label: '业务员离职'
    },
    'ADD_CUSTOMER': {
      value: 5,
      label: '添加客户'
    },
    'CUSTOMER_UPGRADE': {
      value: 6,
      label: '客户身份升级'
    },
    'ADD_SUB_ACCOUNT': {
      value: 7,
      label: '添加子账号'
    },
    'REPLY_COURSE': {
      value: 8,
      label: '回复课程'
    }
  }
}

//佣金来源 佣金来源 1订货 2秒杀 3充值 4学费  5提现 6管理后台扣减 7课程 8会议 9线下凭证升级
function getCommissionSource() {
  return {
    'GOODS_ORDER': {
      value: 1,
      label: '订货'
    },
    'SECKILL_ORDER': {
      value: 2,
      label: '秒杀'
    },
    'RECHARGE_ORDER': {
      value: 3,
      label: '充值'
    },
    'TUITION_ORDER': {
      value: 4,
      label: '学费'
    },
    'WITHDRAW_ORDER': {
      value: 5,
      label: '提现'
    },
    'MANAGE_BACK_ORDER': {
      value: 6,
      label: '管理后台扣减'
    },
    'COURSE_ORDER': {
      value: 7,
      label: '课程'
    },
    'MEETING_ORDER': {
      value: 8,
      label: '会议'
    },
    'OFFLINE_CERTIFICATE_ORDER': {
      value: 9,
      label: '线下凭证升级'
    }
  }
}
export default {
  getCustomerType,
  getSysAddrType,
  getGoodsState,
  getYesOrNo,
  getCommStatus,
  getMenuType,
  getCategorizeType,
  getGoodsAuth,
  getOrderType,
  getUserLevel,
  getSearchUserLevel,
  getLiveAnchorLevel,
  getProcessingType,
  findEnumLabel(value, enums) {
    for (const key in enums) {
      const item = enums[key]
      if (item.value === value) {
        return item.label
      }
    }
    return ''
  }
}
